module.exports = __webpack_public_path__ + "c22e69968437d8c5d467fa22fd33aef7.sofort.svg";


//////////////////
// WEBPACK FOOTER
// ./components/footer/assets/payments/sofort.svg
// module id = c/xv
// module chunks = 0